import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useQuery, NetworkStatus, useApolloClient } from '@apollo/client'
import styled from 'styled-components'

import EmptyState from 'components/v2/EmptyState'
import { Loader } from '@10xLabs/react-web/components/Loader'
import { Button } from 'components/v2/Button'
import { GET_SEATS_TEMPLATE } from 'features/VehicleTemplates/queries-legacy'
import { SeatsTemplate } from '../SeatsTemplate'
import { SeatsTemplateCaption } from '../SeatsTemplateCaption'
import { resolvers as seatsResolvers } from 'resolvers/seats'
import { device } from 'utils/style'
import { GTSeatsTemplateResponse } from 'gql/types.generated'
import { ISeatsTemplateData } from 'features/Bookings/components/EditTrip/SeatsTemplateQuery/types'

const CaptionContainer = styled.div<TSFixMe>`
  margin: 30px 0 0;
  display: flex;
  justify-content: flex-start;

  @media ${device.laptop} {
    justify-content: center;
  }
`

const mapSeatsTemplateToForm = (data: GTSeatsTemplateResponse): ISeatsTemplateData => {
  return {
    ...data,
    seats: data.seats.map((seat) => ({
      ...seat,
      /*@ts-expect-error REMOVE WHEN BACKEND IS READY*/
      preferredSeatPrice: data.seatPrices?.find(({ label }) => label === seat.label)?.price
    }))
  }
}

export const SeatsTemplateQuery = ({
  tripSegment,
  booking,
  oldTickets,
  onStartToReserveSeat,
  isModifyingSameTripSegment,
  ...props
}: TSFixMe): TSFixMe => {
  const client = useApolloClient()
  client.addResolvers(seatsResolvers)

  const { data, loading, error, refetch, networkStatus } = useQuery(GET_SEATS_TEMPLATE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    variables: {
      tripId: tripSegment.tripID,
      segmentId: tripSegment.segment.id
    }
  })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  if (props.loading || loading || networkStatus === NetworkStatus.refetch) {
    return (
      <EmptyState.Container>
        <Loader />
      </EmptyState.Container>
    )
  } else if (props.error) {
    return (
      <EmptyState.Container>
        <EmptyState.Description>
          <FormattedMessage
            id="bookings.edit.trips.error.desc"
            defaultMessage="There was an error while selecting this trip"
          />
        </EmptyState.Description>
      </EmptyState.Container>
    )
  } else if (error) {
    return (
      <EmptyState.Container>
        <EmptyState.Description>
          <FormattedMessage
            id="seats.template.error.desc"
            defaultMessage="There was an error while loading the seats"
          />
        </EmptyState.Description>

        <EmptyState.Action>
          <Button onClick={(): TSFixMe => refetch()} kind="primary">
            <FormattedMessage id="seats.template.error.action" defaultMessage="Try to reload it" />
          </Button>
        </EmptyState.Action>
      </EmptyState.Container>
    )
  } else {
    const seatsTemplate = mapSeatsTemplateToForm(data.seatsTemplate)
    return (
      <>
        <SeatsTemplate
          vehicleTemplate={seatsTemplate.vehicleTemplate}
          seats={seatsTemplate.seats}
          booking={booking}
          oldTickets={oldTickets}
          onStartToReserveSeat={onStartToReserveSeat}
          tripSegment={tripSegment}
          isModifyingSameTripSegment={isModifyingSameTripSegment}
          {...props}
        />

        <CaptionContainer>
          <SeatsTemplateCaption />
        </CaptionContainer>
      </>
    )
  }
}
